export default "__VITE_ASSET__b05d8499__"